import { CommercialPartner } from '../../../../../core/types/entities/partner/commercial-partner'

export interface Option {
    name: string
    id: string
}
export interface UserTypeOption extends Option {
    isInternal: boolean
}

export interface ModalInput {
    partner: CommercialPartner
    accountUserTypes: UserTypeOption[]
}

export enum UserRoleEnum {
    BIZDEV = 'BizDev',
    BUSINESS_DEVELOPER = 'Business Developer',
}
